export const RESTAURANT_STRUCTURE_IDS = [
  '77d30503f715f71ef91c3fe8',
  '5e0c6f7e1802fc0017fdfa39',
  '6024d4e01f75e9001762220f',
  '53a307985ec6701f3b73c928',
  '5f14439dd9456a0017edc4cc',
  'd87632e3733a0aa8ead89d05',
  '89a0cd4df28f8b65ea5996dd',
  '2703cbfc864352670063ea62',
  '5e6e1e7417a77b0018dc6c0c',
  '5ef9aae571ae2c001796e8f0',
  '0a7cd505c23e46c5b490e9e2',
  '5dfa059d67e9270017d1fafd',
  '5e033f571802fc0017fdd74f',
  '5ff6f89295dbbc0017ed9be4',
  '602a15562130cc0017383027',
  'bb04b9712aadb0f3c9b5177a',
  '5cf37815c432580015a26a25',
]

export const BLOG_STRUCTURE_IDS = [
  'b0a520919b99728bae200018',
  // newline preserver
]

export const PHYSICAL_STORE_STRUCTURE_IDS = [
  '5f032d60859a3f00178c1dcc',
  '5e8990a1a1839b00178997a5',
  '77579abf69b1c6bd6726be48',
  '08315294c271eec98e3b1f41',
  '76746b93113b9a86b26edbd3',
  'a66f145339745ae5b5d62d33',
  '5344b9f2a0058d3be498d9d4',
  '0bc120ad2fe7e18f6cf0c8f3',
  'e1a2f009d01ba711cb49a6cb',
  '7fa9b9d0c589fb130a92a894',
  'fdb83cb137cb4ce03bd8d6f6',
  '41d91b03c3189cf19af970e9',
  '78ca987ffcc56b3700ad1c4f',
  '431720e6e1e65930d6bbbcc3',
  '363531a28861adcbe9be3cf5',
  'ce60cecd67422e0eef44b7df',
  '27388b92e83f3e062c9a5a57',
  '73047226bf3c3a5838618cdf',
  'fe2330231227b5623bae10bd',
  'fba0772e6230b75df865dbdc',
  'e6a70a5eb742350b0e357819',
  '71caa1d0683e61e706491aee',
  'a82c47ec07116f80d61defc2',
  '654f7124a6922f34e284a943',
  '26797e2a402eceb6ed2dd055',
  '49d4118fe9dc7312ae1cc1fc',
  '3142071cfdc0d18b30881539',
]

export const ONLINE_STORE_STRUCTURE_IDS = [
  '600952e543af240017d5594c',
  '602a2b00a82f330017e684d0',
  '602e58aca82f330017e688f8',
  '5ec23de43a635c0017d53ae9',
  '5ea7f08ced4e97001721da5d',
  '5d50eae4431c5f001609546c',
  '5d4c1ef4ec51d2001661f45f',
  '5bc6cb099dd89e0014103472',
  '503eb1485f6d9be61cd7440e',
  '55ac5d9bf289db056e9ca2df',
  'ff00aaba40bcd8404c7c15c2',
  'bb605aa1b1a1e21608c1aa50',
  '2641c344379a9aaa8eaab7b2',
  '920d6d4e861dfb385da1016c',
  'f07829409b6a57fced0e0e13',
  '34ffe449f805db7d9bb44c51',
  '3ca1657afcf3c6962bd3850c',
  'dddf5389b593c624fe904f35',
  'a86dc9747f3eede342189f83',
  'e6bd3dc3eea5928b0ea7fd47',
  '073bd83d054dcff87fa0ef50',
  '5e8b0b06b997ac001740fa21',
]

export const BUSINESS_STRUCTURE_IDS = [
  '6086b7d004a35e0016f52b46',
  '600d2090d5240100173d310b',
  '5fbb57ca29e6de00174d3b76',
  '5e8b36eb9e72040019a5df41',
  '08e0945dcce295ab95d1709c',
  '747f2670e38a58823f4dc70c',
  '19c8c17a917e17650c9b1af9',
  '5d4fbdd8431c5f0016094fd3',
  'a3bc0d2c8be51ba4395663ce',
  'df08859c3dea137c0c6244ab',
  '0e74508eb304cf45d26eaf79',
  '53043cf1c224692b9e02b48c',
  '8717f1daa024f434ed295673',
  'f76ddad00a481575dae44c9f',
  '779a362a0578306fdd80f1a5',
  '5d50fd90e3f1f90016822dc4',
  '9656bc91f050d5df3e91db7c',
  'aeefd86543a76cc51781d009',
  '5d4fe167e3f1f9001682295a',
  'ca24aaa201bdb3998e5b0b15',
  '5ef9d6715808290017efc819',
  'd54abdcb7a026264d6f1b7df',
  '561a5c417f2fb9121351049a',
  '4560ebee29d9f23e1b4fb943',
  '2d14e03738730d2f729730f2',
  '493a5210864ae549a0f92832',
  'ba4822515e93680f6bb5c648',
  '5fec07e2985dd8c3ae3d7c18',
  '4cd2cc614945602f6504ba22',
  'ea48792f560028df4fbb3207',
  '5c3c957954963f001cbce325',
  '2eebd86995fb18a4588bf7f9',
  'c3b75e2254171419a22beca4',
  '5f7daff23c66960017496d4e',
  '8d4ce9eee0ba5995ea0f7575',
  '9263f2dcb848e5828d344ee0',
  'ccd31e0dc36d62fd431984f6',
  'b1908deccf1194b3164084ae',
  'eea3d6dfd7a0a74b42d99d1f',
  'af5b893bc1c9270bdf898624',
  '62e99522f3913d6ff89e29e8',
  'bfefcdf90455208ce57fba0d',
  '26ce5a70298faaf6350ba5d1',
  'c484ec94bef2c8871ecdb048',
  'eb0c1b2f9890cfdcad1b5c37',
  'e50f6e10bcd153ff6b4ef8e7',
  '9cb832ab093c3f328f6be318',
  '09e33ad16c590a079d737a41',
  'e9e22c0c1a594e564005e542',
  'b0ffff30cfe326e316345b81',
  'e9802e89f8e1862c01fb6203',
  '769eacfcf310ae96103cd210',
  '0b9fbbe30973a70b76e01ef5',
  'ddcf01985bb895180fddde3b',
  'ce91441e32f1a45e0625783b',
  '5ee9ad759ee393001715760c',
  '16dcae2e733f6dcb0843d673',
  'ff8e8c36452f407f5c87c455',
  '3bb14e66865a11fd85762592',
  '5f7d5a08e8a49a0017a77f8e',
  'a12fd69889a62f597bef8715',
  '2edc14cf7c0a5f8694a7bc35',
  '844f6823d299303fcf521e3c',
  '2992ac823a91f1c19e801edb',
  '988ab89bc16ba8f03747ab9d',
  '693a95433a86eb32809922a0',
  'c79d68d9b2e661b7a89cec3a',
  '3fb3a4ba001dc048488331be',
  '620ccf5635db87834f2e2948',
]

export const BOOKING_FIRST_STRUCTURE_IDS = [
  '051fe5099bdf019504c0f739',
  'c7a36e2e06764fb6a4f7c285',
  '4d377ecf721f56f13cf2c919',
  '723c7fcd6878221197b4addb',
  '3eb24458ed7216b1eabb2e94',
  '190a5ffad4f67ad6e22ad08d',
  '5115f39a3c9dc70bdce69b77',
  '8da01badf395e3300cbc1bc4',
  'dc4a5619f17328bd06b38899',
  'e672ff2a2a0edaacfab8021d',
  'd52c7057b8f5038522203aaf',
  'a9f92ade8d09565e34bb69d6',
  '89fa91123688531f0a4ba0ce',
  '12aa19bcaf4a2cec85fb2e47',
  '5c3c7b1454963f001cbcd369',
  '75688f274a950a2916f75b14',
  '5cf045c939e68000158a4464',
  '28e95344ac1c3b2a8f8b4cdc',
  '40500ea9d54561e2ca8e4a8a',
  '0d2fbf421f7673baae61d226',
  '5f057b4383762c0017b96a51',
  '5eb932ca20ff2b0017946414',
  'ad457ab24372e3376ee8825a',
  '9562df22b947d92c05894cfe',
  'd4f37e8bdc345332955c0801',
  '608f9ee4d2d59600158b0a27',
  '5fdb390b91f0c400178d0ef3',
  'e0ef733494f2fae509ab53ea',
  '155249e1f27d95ef5057e337',
  '482d4178d8f6458f17da0add',
  '34abcefedabc5fbaa15bbf3c',
  'bf61b613f48c3e7af17cfc6c',
  'b595a1c71d3071ddc45975c6',
  'ac7d8bdd717cfcfae3b74786',
]

export const BOOKINGS_EXTENDED_STRUCTURE_IDS = [
  '6796cebe34d21cca1400d748',
  '7e5b50a94082f1476c1683ee',
  '61bb263a79789b001659f0b0',
  '5ddb5a773921918dee3af348',
  '7e9cb49af16330627a3c98fd',
  'aa2ebd7327a778859afbe02a',
  '60a5187ddc61310016ca3e57',
  '5c3ca18baebef4001ca0db79',
  'c9eddd377e1a194896c3637c',
  '2f4695db2de882a5b3147f4e',
  'b7d65b9733cad4363446dfbb',
  '0f04c68cffed335f82caabfa',
  '2e0d3d3432112b324361895a',
  '2005a71d36969ed011f7ab88',
  '5fdb172d91f0c400178d0ea1',
  '99efa813813978f03b9becf1',
  'e234142730d6fa2e8be4dcf7',
  'dd5b9c5ff59efed910fdec6f',
  '9961911671709492501a101d',
  'b4aa16c8f1295c2f56edfcaf',
  '963bfe1ba24ee03df24f807d',
  'ee1f9dbf15f228ad170819ae',
  '462023302a1c42fd22449965',
  '3153433e9e515acbb8187d4e',
  '5bfd92ea0261ae001af5b477',
  '5fa8e46f38d9160017d69fb4',
  '6a0443350f4cab0e994b0fc6',
  'b4d27d72f66ab52c276a9c92',
  '5d501264431c5f001609525c',
  '6125e532f711ae00169d1efb',
  'f28fbeb9e044f8e3cfa93f56',
  'bd127f2a9a07f3178390440e',
  '88e4eef5065c89f921313c3f',
  'c198cf0a69f990711dedbb72',
  '5ce65df82119100032368f0d',
  'c4351a57eecc8af092f798bc',
  '5ee9c7859ee3930017157662',
  '3278ba04c3340b40d058ed5f',
  '8c98ef7080e76f5c6b4cb8de',
  'd17977f81fb5e03e126378e2',
  '320bc14e388b60c6ab499242',
  '1e59ef5bda56d5fb23037d4a',
  '3adcda87e9f400e319e6351a',
  'dca8b81299b472a2f43d3239',
  '16f33903e614854d62828658',
  'c9e7b6e466395dae61b94d1c',
  '5c406b56aebef4001ca106d3',
  'dcb2a9ceb358ee6005ab1a58',
  'fa28a6f03dbe530a8a8c6fcc',
  '18025d42bfe2067427041843',
  'ef0e83f2dd3e5f2de57ed162',
  'afee35922f1083c84a62b114',
  'cba925039ed9d3d360590d31',
  'dc92558c4b6d316b91a1c493',
  '5c558ae3297567001b9da547',
  '42102d8e66b6a86eb5d95212',
  '8d0b797364022c8f663e82ed',
  '42dcb2e7e1af7666c2f5cf57',
  '8a11fb82979eddf2a0ae423f',
  '424877f1768bf045fedcf7bd',
  '5e745b1b90bf5c79a42cb889',
  '45c1ca3d3bc48f2a67d648b0',
  '7c8deffd2f91974fb022c750',
  'db5f23d71a5963e2838635b1',
  'a64a4321b4484599dd41fe3d',
  'bb6fe664d024cba4869c1898',
  '72ffeb33127e2da8c0bb763f',
  '9829db146302a5d86ced8864',
  '8ccc686ed6279ed5b30503c4',
  '74c54b103c2f81a197292f3e',
  '5b4a8836a131ccaf97d6deaa',
  '5d6ce0dfb4af1a0016ad5709',
  'fe4c6edcf05c436a0fb720f1',
  'e51e11f3597e0c565deb792f',
  '0fdf8f7c1fd0fb710ecb8826',
  'd928698035d6b2a193f89536',
  '9326d9e1269ccde213a1bcd8',
  '6e3c94eb494ab624953e8e6f',
  '5ef9ba5553f7800019a06ad2',
  '6076cb0f5b9db9001537f659',
  '5e89d189a1839b0017899947',
]

export const GENERAL_BOOKINGS_STRUCTURE_IDS = [
  'd5f66b51bb779fcb72894300',
  '87de0335f09ebc252139974c',
  '5603bb67000870d80c53d49d',
  '7d9f2f2d93d10adfb06b97f8',
  '5e044c7ae3604900178a0af2',
  '85e863670516fb8906c99203',
  '8c467a3792cd3d9c6db3c138',
  'a4a33900f45ca67110f2dfc4',
  '4c41f36c745880e6e42c5838',
  '9b888a944e35417b0916e075',
  '5018df1225db2457336b5e8f',
  'a1e6a5704d3f71fce8dd0dc9',
  'cd56860bcbe70d98fcfb09a0',
  'be6f1d8dc988d56f886ed440',
  'eb1243457ba9d8838db2d09f',
  '4ade3f4685da59f5e1820ea0',
  '0837f731efda8f1385b4ec89',
  '19c94bf114b4d54a46a71121',
  '6d7f42e2d8c0477f6dafda7f',
  '5c3cb0d0aebef4001ca0e4d8',
  '6024f4310eed2e00173d254c',
  '5c4055e1aebef4001ca10333',
  'f5feb80464366af988623685',
  'e34f3d3221e0000ef9c482be',
  '626f4c3c359fff94722f9af5',
  '5ee08fcf6a2c2d0017c74847',
  'e91dcc2ca66d2f7209558e4e',
  '75fc02ae921421a6219b5269',
  'c5c1f3c63915119ed5c7feff',
  '59b02f109bae3a2f4eabd359',
  '1b6df06955834f25bfa49cf9',
  'b5ab898f0afbfec00845808e',
  '1940a5b90fdc938cc491bb12',
  '1d4e866e3486d091540cc31e',
  '952c721cf3bae9b01eccd77e',
  '5dec9bcdb2553b00178182ef',
  '29b26e536c51bd1a2445fbe9',
  '94d4b55ce16bd162b833e148',
  'dbcd2ec9e34eb43b441b8a03',
  '481a36b3eeb98dbfc2f904a6',
]

export const FITNESS_BOOKINGS_STRUCTURE_IDS = [
  '714a7d52812e0df69b1634a3',
  '5fb61ada96417edd325f09eb',
  '5df51a2bdce21148ecd41472',
  '6048aa84be2ee2001584d159',
  '55d4e81833bc9eada9dffd0c',
  '604f0ed3630fc000153966b2',
  '1be1cd28dd126c4e7e3f6cc4',
  '6065650afbbe520016463a5f',
  '606ac8d29e0f160015f30f86',
  '605af0f3fe3f910015cc149e',
  '606dbcae0eadef00152ad236',
  '50ce6fbf481e5e0cccc7ed89',
  '604f543340a7c00015ced3fd',
  '60587061f8b7ca0015556976',
  '606dccf80eadef00152ad290',
  '605b016f366ce30015eef265',
  '606aa85b51678800159f40eb',
]

export const HEALTH_BOOKINGS_STRUCTURE_IDS = [
  'b8d21e2578cf123e82edb891',
  '613dc14cc48b550016cba889',
  'fcd09bfdc003d44618676185',
  'ec050eb388cedd7751435395',
  '5d0794ffd8433700164f0445',
  '5c80f6890de30f001c1fe411',
  '62e5f1e5d3e46d80e5a17229',
  '61e00c9a5e4e3300161ee573',
  '5c49b07ba710ba001cda5d3d',
]
